import { isFeatureEnabled } from 'owa-feature-flags';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    ConfettiOptions,
} from 'owa-outlook-service-options';

export default function isConfettiEnabled(): boolean {
    return (
        isFeatureEnabled('mc-confetti') &&
        getOptionsForFeature<ConfettiOptions>(OwsOptionsFeatureType.Confetti).confettiEnabled
    );
}
